import styled from 'styled-components';

export const ProfileContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 3.2px 7.2px 0px rgba(0, 48, 72, 0.12), 0px 0.6px 1.8px 0px rgba(0, 48, 72, 0.1);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
`;

export const ContentImage = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ImageProfile = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
`;

export const ProfileTitle = styled.h2`
  text-align: center;
  margin-bottom: 20px;
  color: #333;
`;

export const ProfileForm = styled.div`
  gap: 15px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  font-weight: 600;
  margin-bottom: 5px;
  color: #666;
`;

export const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  color: #333;
  
  &:disabled {
    background-color: #e9ecef;
  }
`;

export const EditButton = styled.button`
  padding: 10px;
  background-color: #03324c;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`;

export const ChangePhotoButton = styled(EditButton)`
  display: flex;
  align-items: center;
  background-color: #333;
  min-width: auto;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: normal;
  &:hover {
    background-color: #555;
  }
`;
